import step2json from '@/store/step2json';
import { _getFields, getAllBaseFields } from '@ifr/form-questionnaire/src/plugins/formUtilites';
import {
  IBaseField,
  IBaseSection,
  IEntityField,
  isBaseField,
  isBaseSection,
  isEntitySection,
  isSection,
  isTextareaOrInput,
  TField,
  TSection,
  fieldCanBeParent,
} from '@ifr/form-questionnaire/src/types/Elements';
import { Module } from 'vuex';
import { RootState } from '@/store/index';

export interface IFieldDescription {
  type: string;
  name: string;
}
export type Journal = Map<string, IFieldDescription>;
export interface FormBuilderState {
  _journal: Journal; //only BaseFields
  _journalFields: Journal;
  selectedSourceIds: Set<string>;
  json: TSection[];
}
interface PayloadSetField {
  data: IBaseField;
  i: number;
  j: number;
}

export interface IPayloadUpdateChildrenByParentId {
  parentId: string;
  callback: (item: IBaseField | IBaseSection | IEntityField) => void;
}

const storeModule = <Module<FormBuilderState, RootState>>{
  // namespaced: true,
  state: {
    _journal: new Map(),
    _journalFields: new Map(),
    selectedSourceIds: new Set(),
    json: step2json.slice(),
  },
  mutations: {
    setJournal(state, field: TField) {
      state._journal.set(field.id, {
        type: field.name,
        name: field.label,
      });
    },
    setJournalFields(state, field: IBaseField) {
      if (isTextareaOrInput(field)) {
        state._journalFields.set(field.id, {
          type: field.type,
          name: field.label,
        });
      }
    },
    setSelectedSourceIds(state, id: string) {
      state.selectedSourceIds.add(id);
    },
    delSelectedSourceIds(state, id: string) {
      state.selectedSourceIds.delete(id);
    },
    clearJournal(state) {
      state._journal.clear();
      state._journalFields.clear();
    },
    delJournal(state, id: string = '') {
      state._journal.delete(id);
      state._journalFields.delete(id);
    },
    setJson(state, quest: TSection[] = []) {
      state.json = quest;
    },
    //Редактирование json-представления базового поля baseField
    setField(state, { data, i = 0, j = 0 }: PayloadSetField) {
      let section: TSection = state.json[i];
      if (isSection(section)) {
        if (section.fields) {
          section.fields.splice(j, 1, data);
        } else if (isEntitySection(section) && section.blocks) {
          //participants, counterparties
          section.blocks[0].fields.splice(j, 1, data);
        }
      } else {
        throw new Error('Изменяемое значение не находится в разделе');
      }
    },
    //todo Я считаю, что для красоты этот метод можно отсюда изъять, а здесь оставить пустышку для обновления рендеринга, реактивности.
    //М.б. я ошибаюсь, и так компактнее
    updateChildrenByParentId(state, { parentId, callback }: IPayloadUpdateChildrenByParentId) {
      state.json.forEach((element) => {
        let children: (IBaseField | IBaseSection | IEntityField)[];

        children = <IBaseField[]>_getFields(element).filter((field) => isBaseField(field) && field.parent.id && field.parent.id == parentId);

        if (isBaseSection(element) && element.parent && element.parent.id && element.parent.id == parentId)
          children.push(element);

        children.forEach(callback);
      });
    },
    updateChildrenBySourceId(state, { parentId: sourceId, callback }: IPayloadUpdateChildrenByParentId) {
      getAllBaseFields(state.json)
        .filter((field) => field.idSourceField === sourceId)
        .forEach(callback);
    },
  },
  actions: {
    setJournalAllFields({ state, commit }, json: TSection[] = state.json) {
      getAllBaseFields(json).forEach((field) => {
        commit('setJournalFields', field);
      });
    },

    /*
        deleteField({state, commit}, field: TField){
          if (field.name === 'signatory') {
            const fields = findFieldsByName(state.json, 'signatory');

            fields.forEach((field, i)=> {
              const oldId = field.id;
              const matches = field.id.match(/^(.+?)(?:_\d+)?$/) || [];
              const [,key] = matches;
              field.id = `${key}_${i+1}`;

              commit('delJournal', oldId);

          commit('setJournal', field);
        });
      }
    },
*/
    addJournal({ state, commit }, field: IBaseField) {
      if (field.id && fieldCanBeParent(field)) {
        commit('setJournal', field);
      }
    },
  },
  getters: {
    json: (state): TSection[] => state.json,
    journalId: (state): Journal => state._journal,
    journalFieldsId: (state): Journal => state._journalFields,
    selectedSourceIds: (state): Set<string> => state.selectedSourceIds,
  },
};

export default storeModule;
